export const TOP_BAR_ID = "top-bar";

export const ROOT_ID = "root";

export const PLACEHOLDER = "placeholder";
